var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapBedMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a2 2 0 0 0-2 2v23.077a2 2 0 0 0 2 2h12.19L21.746 33l4.557-4.923H38a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a2 2 0 0 0-2 2v23.077a2 2 0 0 0 2 2h12.19L21.746 33l4.557-4.923H38a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H5Z",
    fill: "#0D99D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.19 28.077 1.467-1.359-.594-.641h-.873v2ZM21.746 33l-1.468 1.359 1.468 1.585 1.467-1.585L21.747 33Zm4.557-4.923v-2h-.874l-.594.641 1.468 1.359ZM5 3v-4a4 4 0 0 0-4 4h4Zm0 23.077V3H1v23.077h4Zm0 0H1a4 4 0 0 0 4 4v-4Zm12.19 0H5v4h12.19v-4Zm6.024 5.564-4.557-4.923-2.935 2.718 4.557 4.923 2.935-2.718Zm1.622-4.923-4.557 4.923 2.935 2.718 4.558-4.924-2.936-2.717ZM38 26.077H26.304v4H38v-4Zm0 0v4a4 4 0 0 0 4-4h-4ZM38 3v23.077h4V3h-4Zm0 0h4a4 4 0 0 0-4-4v4ZM5 3h33v-4H5v4Z",
    fill: "#fff",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.41v11.282m0-4.102h18.5m0 4.102v-8.205a2.058 2.058 0 0 0-2.056-2.051h-8.222v6.154",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.361 13.512a1.027 1.027 0 1 0 .002-2.053 1.027 1.027 0 0 0-.002 2.053Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 43,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBedMarker);
export default __webpack_public_path__ + "static/media/map-bed-marker.19f7ad8c00b13fc70eb7af6cb0e2ed3d.svg";
export { ForwardRef as ReactComponent };